define('app/views/travel_residence_details_view',['app/setup'],
  function (takhfifan) {

    takhfifan.travelResidenceDetailsView = Backbone.View.extend({
      events: {
        "click .tkh-travel-residence-package__reserve": "reserve",
        "click .tkh-travel-residence-package__un-reserve": "unReserve",
        "click .tkh-hotel-details__reserve-btn": "submit"
      },

      template: ( $('#travel-residence-details-template').length > 0 ) ?
        _.template($('#travel-residence-details-template').html()) : '',

      initialize: function () {
        takhfifan.eventHub.on('travel:viewChanged', function (options) {
          if (options.view === "residence") {
            takhfifan.eventHub.trigger('travel:disable');
            this.cartData = {
              vendor_name: '',
              parentId: null,
              totalPrice: 0,
              rooms: 0,
              beds: 0,
              details: []
            };
            this.renderResidenceDetails(options.id);
          }
        }, this);

        this.cartData = {
          vendor_name: '',
          parentId: null,
          totalPrice: 0,
          packages: 0,
          details: []
        };
      },

      renderResidenceDetails: function (hotelId) {
        var _this = this,
          persistedData = Lockr.get('travelHotelData'),
          dataUpdatedTime = (persistedData && persistedData.time) || undefined;

        if (!persistedData || !persistedData.hotels || !persistedData.search || !persistedData.time) {
          this.$el.addClass('travel-hotel-details--no-result');
          return;
        }

        if (dataUpdatedTime) {
          var currentTime = new Date();
          if (currentTime - persistedData.time > 15 * 60 * 1000) {
            Lockr.set("travelHotelData", {});
            this.$el.addClass('travel-hotel-details--no-result');
            return;
          }
        }

        var hotelModel = persistedData.hotels && _.find(persistedData.hotels, function (hotel) {
            return (hotel.id == hotelId);
          });
        var searchModel = persistedData.search;

        if (hotelModel) {
          this.hotelModel = hotelModel;
          this.cartData.parentId = hotelId;
          this.cartData.vendor_name = hotelModel.vendor_name;
          this.cartData.name = hotelModel.name;
          _this.$el.removeClass('travel-hotel-details--no-result');
          $('.tkh-travel-residence-details__content').html(
            _this.template({
              residence: hotelModel,
              search: {
                checkin: searchModel.checkinJalali,
                checkout: searchModel.checkoutJalali,
                person: searchModel.person,
                city: searchModel.cityName,
                nights: searchModel.nights
              }
            })
          );
          $.ajax({
            url: '/ajax/product/getChildDetails/',
            type: "GET",
            data: {
              pid: hotelId,
              form_key: takhfifan.formKey
            }
          }).done(function (data) {
            _.extend(hotelModel, data);
            $('.tkh-travel-residence-details__content').html(
              _this.template({
                residence: hotelModel,
                search: {
                  checkin: searchModel.checkinJalali,
                  checkout: searchModel.checkoutJalali,
                  person: searchModel.person,
                  city: searchModel.cityName,
                  nights: searchModel.nights
                }
              })
            );
            new takhfifan.GoogleMapView({el: $('#map-canvas')});
          }).fail(function () {
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: "در برقراری ارتباط خطایی پیش آمد"
            });
          }).always(function () {
            takhfifan.eventHub.trigger('travel:enable');
          });
        } else {
          this.$el.addClass('travel-hotel-details--no-result');
          takhfifan.eventHub.trigger('travel:enable');
        }
      },

      reserve: function (e) {
        e.preventDefault();
        var $target = $(e.target),
          $packageCard = $target.parents('.tkh-travel-residence-package');

        this.cartData.details.push({
          id: $packageCard.data('id'),
          count: $packageCard.find('.tkh-travel-residence-package__count').val()
        });
        $packageCard.addClass('travel-hotel-room--reserved');
        this.notifyUser();
      },

      unReserve: function (e) {
        e.preventDefault();
        var $target = $(e.target),
          $packageCard = $target.parents('.tkh-travel-residence-package'),
          id = $packageCard.data('id');

        this.cartData.details = _.without(this.cartData.details, _.findWhere(this.cartData.details, {
          id: id
        }));

        $packageCard.removeClass('travel-hotel-room--reserved');
        this.notifyUser();
      },

      notifyUser: function () {
        var _this = this,
          totalPrice = 0,
          packages = 0;
        _.each(this.cartData.details, function (item) {
          var packageDetail = _this.hotelModel && _.find(_this.hotelModel.children, function (package) {
              return (package.id == item.id);
            });
          if (packageDetail) {
            item.name = packageDetail.name;
            item.price = packageDetail.price;
            totalPrice += packageDetail.price * parseInt(item.count);
            packages += parseInt(item.count);
          }
        });

        if (totalPrice > 0) {
          var template = _.template("" +
            "<%=packages %> مورد به مبلغ : <%=totalPrice%> ");
          this.$('.tkh-residence-details__reserve-detail').html(template({
            packages: packages,
            totalPrice: formatPrice(totalPrice)
          }));
          this.$('.tkh-residence-details__reserve-btn').removeClass('disabled');
          $('.travel-hotel-details__cart').removeClass("hide");
          this.cartData.totalPrice = totalPrice;
          this.cartData.packages = packages;
        } else {
          this.cartData = {
            totalPrice: 0,
            packages: 0,
            details: []
          };
          this.$('.tkh-residence-details__reserve-detail').html('');
          this.$('.tkh-residence-details__reserve-btn').addClass('disabled');
          $('.travel-hotel-details__cart').addClass("hide");
        }
        takhfifan.eventHub.trigger('travel:persist-hotel', {cart: this.cartData});
      },

      submit: function (e) {
        // e.preventDefault();
      }

    })
  });

